import { useState } from "react";
import { useTranslation } from "react-i18next";
import SupplierSearch from "../../../Components/Inputs/SupplierSearch";
import NewStockSearch from "../../../Components/Inputs/NewStockSearch";
import { useApiMutation } from "../../../Hooks/useApiMutation";
import instance from "../../../Interceptor/api_instance";
import { Spinner } from "../../../Components/LoadingAnimations/LoadingAnimations";

const CreateLineItem = ({ close, receiptId, setData, setFeedback, locationId }) => {
  const { t } = useTranslation();
  const [formData, setFormData] = useState({
    stock: null,
    quantity: 0,
    unit_price: 0,
  });

  const {
    mutate: createItem,
    isLoading,
    error,
  } = useApiMutation(async (e) => {
    e.preventDefault();
    const res = await instance.post(
      `/safety/receipts/${receiptId}/line-items/`,
      {
        ...formData,
        stock: formData.stock.value,
        unit_price: parseFloat(formData.unit_price),
      },
    );
    if (res.status === 201) {
      setData((prev) => ({
        ...prev,
        line_items: [...prev.line_items, res.data],
      }));
      setFeedback({ message: "Line item created successfully", variant: "success" });
      close();
    }
  });

  return (
    <div className="page-mask page-mask-animation">
      <div className="page-mask-cont">
        <h2 className="global-h4 black">Create Line Item</h2>
        <form onSubmit={createItem}>
          <div className="form-block">
            <label className="required">SKU</label>
            <div className="input-cont">
              <NewStockSearch
                locationId={locationId}
                onSelect={(option) =>
                  setFormData({ ...formData, stock: option })
                }
                selectedOption={formData.stock}
              />
            </div>
          </div>
          <div className="form-block">
            <label className="required">Quantity</label>
            <input
              type="number"
              className="text-input"
              value={formData.quantity}
              min={0}
              onChange={(e) =>
                setFormData((prev) => ({
                  ...prev,
                  quantity: e.target.value,
                }))
              }
            />
          </div>
          <div className="form-block">
            <label className="required">Unit Price</label>
            <input
              type="number"
              className="text-input"
              step="0.01"
              min={0}
              value={formData.unit_price}
              onChange={(e) =>
                setFormData((prev) => ({ ...prev, unit_price: e.target.value }))
              }
            />
          </div>
          {error && <p className="error">{error}</p>}
          <div className="full-cont">
            {isLoading ? (
              <Spinner />
            ) : (
              <>
                <button className="change-pwd-btn" type="submit">
                  {t("buttons.submit")}
                </button>
                <button className="cancel-btn" type="button" onClick={close}>
                  {t("buttons.cancel")}
                </button>
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateLineItem;
